import React from 'react'

import { CTATheme, getColorTheme, ITheme, LegacyColor, mq } from '../../utils'
import { CTA, ICTA } from 'marketing-site/src/transformers/CTA'
import { Text } from '../../elements/Text'
import { NewSticker } from '../../elements/NewSticker'
import { IProps } from './index'

import { NewBrandingHoc } from '../../utils/NewBrandingHoc'
import { RooflineBanner as RooflineBannerDefault } from './component'

interface ILocalTheme extends ITheme {
  stickerTheme: LegacyColor
}

const getLocalTheme = (backgroundColor: LegacyColor): ILocalTheme => {
  const baseColors = getColorTheme('legacy', backgroundColor)
  switch (backgroundColor) {
    case LegacyColor.LightGray:
      return {
        ...baseColors,
        ctaTheme: CTATheme.LinkOnlyBlack,
        stickerTheme: LegacyColor.Teal,
      }

    case LegacyColor.Teal:
      return {
        ...baseColors,
        ctaTheme: CTATheme.LinkOnlyBlack,
        stickerTheme: LegacyColor.LightBlue,
      }

    case LegacyColor.Purple:
    case LegacyColor.Blue:
      return {
        ...baseColors,
        ctaTheme: CTATheme.LinkOnlyWhite,
        stickerTheme: LegacyColor.Teal,
      }

    case LegacyColor.LightBlue:
      return {
        ...baseColors,
        ctaTheme: CTATheme.LinkOnlyBlack,
        stickerTheme: LegacyColor.Purple,
      }

    case LegacyColor.Yellow:
    default:
      return {
        ...baseColors,
        ctaTheme: CTATheme.LinkOnlyBlack,
        stickerTheme: LegacyColor.LightBlue,
      }
  }
}

export const RooflineBannerLegacy: React.FC<IProps> = ({
  message,
  backgroundColor,
  showNewIcon,
  cta,
}) => {
  const themeColors = getLocalTheme(backgroundColor as LegacyColor)

  return (
    <>
      <div className="roofline-banner">
        {showNewIcon && (
          <div className="roofline-banner__new-sticker">
            <NewSticker theme={themeColors.stickerTheme} />
          </div>
        )}
        {message && (
          <div className="roofline-banner__message">
            <Text size="body">{message}</Text>
          </div>
        )}
        {cta && (
          <div className="roofline-banner__cta">
            <CTA {...(cta as ICTA)} />
          </div>
        )}
      </div>
      <style jsx>
        {`
          .roofline-banner {
            display: none;
            position: sticky;
            background-color: ${themeColors.backgroundColor};
            padding: 16px 24px;
            overflow: hidden;
            z-index: 200; /* stay above HeaderNav z-index */

            * + * {
              margin: 0.5rem 0 0;
            }
          }

          .roofline-banner__message {
            color: ${themeColors.textColor};
          }

          @media (${mq.tablet}) {
            .roofline-banner {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
          }

          @media (${mq.desktop}) {
            .roofline-banner {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: center;

              * + * {
                margin: 0 0 0 1rem;
              }
            }
          }
        `}
      </style>
    </>
  )
}

export const RooflineBanner = NewBrandingHoc(RooflineBannerLegacy, RooflineBannerDefault)
